import { render } from "./PricingCalendarRange.vue?vue&type=template&id=0806af34&ts=true"
import script from "./PricingCalendarRange.vue?vue&type=script&lang=ts"
export * from "./PricingCalendarRange.vue?vue&type=script&lang=ts"

import "./PricingCalendarRange.vue?vue&type=style&index=0&id=0806af34&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__